import { useRefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

const SurvivorshipFacet = () => {
  const survivorShipList = useRefinementList({
    attribute: 'survivorshipProgram',
  });
  const handleTypeSelect = (facet: string) => {
    survivorShipList.refine(facet);
  };

  return (
    <div>
      <div
        className={classnames(
          'text-blue-night',
          'mb-4',
          'flex',
          'w-full',
          'justify-between',
          'lg:text-lg'
        )}
      >
        {survivorShipList.items
          .filter((x) => x.value === '1')
          .map((x) => {
            const checkboxId = x.value.replace(/\s+/g, '');
            return (
              <div
                key={checkboxId}
                className={classnames('flex', 'w-full', 'pb-4', 'text-solidBlack')}
              >
                <input
                  type="checkbox"
                  name={x.value}
                  value={x.value}
                  id={checkboxId}
                  title="Survivorship Programs Only"
                  checked={x.isRefined}
                  onChange={(e) => handleTypeSelect(e.currentTarget.value)}
                  className={classnames('min-w-[24px]', 'h-6', 'accent-blue-morning')}
                />
                <span
                  className={classnames('pl-4', 'w-full', 'text-base')}
                  id="SurvivorshipCentersOnly"
                >
                  Only include centers with Survivorship programs
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SurvivorshipFacet;
